import { attr, belongsTo, hasMany } from '@ember-data/model';
import AbstractAgreementPageModel from 'garaje/models/abstract/abstract-agreement-page';
import NDA_TEXT from 'garaje/utils/nda-text';
import adapter from 'garaje/utils/decorators/adapter';

@adapter('agreement-page')
class GlobalAgreementPageModel extends AbstractAgreementPageModel {
  @hasMany('global-agreement') agreements;
  @belongsTo('global-flow') flow;

  @attr('string', { defaultValue: NDA_TEXT }) body;
}

export default GlobalAgreementPageModel;
